module.exports = __webpack_public_path__ + "img/vms_ico_4.c5c38182.svg";